module.exports = __webpack_public_path__ + "img/_ABS9765.7fe7b412.jpg";